import { makeAutoObservable } from 'mobx';
import { MobxObjectsManager } from './page/mobx-objs/mobx-manager';


export class RouterManagerModule {

    constructor() {
        makeAutoObservable(this);
    }

    history: any

    bindHistory(history: any, ) {
        this.history = history
    }
}


export const routerManager = MobxObjectsManager.get(RouterManagerModule)
